import React, { ReactNode } from 'react';

import { Button } from '../styles';

interface ButtonProps {
  onClick(): any;
  style?: any;
  children?: ReactNode;
  disabled?: boolean;
  title?: string;
}

export const ClearButton: React.FC<ButtonProps> = ({
  onClick,
  style,
  children,
  disabled = false,
  title = '',
}) => {
  return (
    <Button
      type="button"
      onClick={onClick}
      style={style}
      className="clear"
      disabled={disabled}
      title={title}
    >
      {children || 'Limpar'}
    </Button>
  );
};

export default ClearButton;
